import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { API, apiError, input, lbl, primaryBtn, setToken } from "./ambassadorApi";

const link = "font-mono-d text-[10px] uppercase tracking-[0.2em] text-[#5f5e5a] hover:text-[#ff2a85] transition-colors";

export const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await axios.post(`${API}/ambassadors/login`, { email, password });
      setToken(r.data.token);
      navigate("/ambassadors/dashboard");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form data-testid="ambassador-login-form" onSubmit={submit} className="space-y-4">
      <div><label htmlFor="amb-login-email" className={lbl}>Email</label><input id="amb-login-email" data-testid="amb-login-email" type="email" className={input} value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
      <div><label htmlFor="amb-login-password" className={lbl}>Password</label><input id="amb-login-password" data-testid="amb-login-password" type="password" className={input} value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
      <button type="submit" data-testid="amb-login-submit" disabled={busy} className={primaryBtn}>{busy ? <Loader2 size={14} className="animate-spin" /> : null} Sign in</button>
      <div className="flex items-center justify-between pt-2">
        <Link to="/ambassadors/forgot" data-testid="amb-forgot-link" className={link}>Forgot password?</Link>
        <Link to="/ambassadors/register" data-testid="amb-register-link" className={link}>Join the Crew</Link>
      </div>
    </form>
  );
};

export const ForgotForm = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/ambassadors/forgot-password`, { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };
  if (sent) return <p data-testid="amb-forgot-sent" className="rounded-2xl border border-[#e3e2dc] bg-[#faf9f6] p-5 text-sm leading-relaxed">If an Ambassador account exists for <strong>{email}</strong>, a reset link is on its way. It works for 1 hour — check spam if you don't see it.</p>;
  return (
    <form data-testid="ambassador-forgot-form" onSubmit={submit} className="space-y-4">
      <div><label htmlFor="amb-forgot-email" className={lbl}>Email</label><input id="amb-forgot-email" data-testid="amb-forgot-email" type="email" className={input} value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
      <button type="submit" data-testid="amb-forgot-submit" disabled={busy} className={primaryBtn}>{busy ? <Loader2 size={14} className="animate-spin" /> : null} Email me a reset link</button>
      <Link to="/ambassadors/login" data-testid="amb-back-login" className={link}>Back to sign in</Link>
    </form>
  );
};

export const ResetForm = () => {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await axios.post(`${API}/ambassadors/reset-password`, { token: params.get("token") || "", password });
      toast.success("Password updated — sign in with your new password.");
      navigate("/ambassadors/login");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form data-testid="ambassador-reset-form" onSubmit={submit} className="space-y-4">
      <div><label htmlFor="amb-reset-password" className={lbl}>New password (8+ characters)</label><input id="amb-reset-password" data-testid="amb-reset-password" type="password" className={input} value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} /></div>
      <button type="submit" data-testid="amb-reset-submit" disabled={busy} className={primaryBtn}>{busy ? <Loader2 size={14} className="animate-spin" /> : null} Save new password</button>
    </form>
  );
};
